import { t, useI18n } from "@bookingcom/lingojs-react";
const useExtraProductsInfo2Controller = (flight) => {
    const i18n = useI18n();
    return {
        header: i18n.trans(t("flights_bp_ancillaries_extra_baggage_heading")),
        baggageText: flight.extraProductDisplayRequirements?.baggage?.text
    };
};
export default useExtraProductsInfo2Controller;
